export default __webpack_public_path__ + "static/media/jen_membership3.ea6a8f32.svg";